export default __webpack_public_path__ + "static/char-s-10-jp-25be371de2b109240a65b6e6642739e7.webp";